<script setup lang="ts">
import { selectedOrder } from '@/event/account/dashboard/history/selectedOrder'
import { showSelectedOrder } from '@/event/account/dashboard/history/showSelectedOrder'
import { changeInvoiceNo } from '@/utils/account/dashboard/changeInvoiceNo'
import { statusOrder } from '@/utils/order/statusOrder'

function toggleModalShowOrderHappy() {
    showSelectedOrder.value = false

    // if (selectedOrder.value) {
    //     document.body.style.overflow = 'hidden'
    // } else {
    document.body.style.overflow = 'auto'
    // }
    setTimeout(() => {
        selectedOrder.value = undefined
    }, 300)
}
const getPaidClass = (order: any) => {
    return order.payment_status === 'Réglé' ? 'success' : 'error'
}
</script>

<template>
    <section class="section-modal-show-order-happy" v-if="selectedOrder !== undefined">
        <section
            class="section-overlay-modal-show-order-happy"
            @click="toggleModalShowOrderHappy()"
        ></section>

        <transition
            enter-active-class="transition-all duration-300 ease-in-out"
            enter-from-class="opacity-0 -translate-y-4"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition-all duration-300 ease-in-out"
            leave-from-class="opacity-100 translate-x-0"
            leave-to-class="opacity-0 -translate-y-4"
        >
            <section
                class="section-content-modal-show-order-happy"
                v-if="showSelectedOrder"
            >
                <div
                    class="header-show-modal-order-happy"
                    v-if="changeInvoiceNo(selectedOrder?.invoice_no) !== ' Annulée'"
                >
                    Commande n° {{ changeInvoiceNo(selectedOrder?.invoice_no) }}
                </div>
                <div v-else class="header-show-modal-order-happy">
                    Commande {{ changeInvoiceNo(selectedOrder?.invoice_no) }}
                </div>

                <section class="section-content-internal-modal-show-order-happy">
                    <section class="section-infos-modal-show-order-happy">
                        <div class="div-first-content-modal-show-order-happy">
                            <p>{{ selectedOrder.date_added }}</p>
                            <p class="text-modal-order-happy">
                                Total :
                                <span class="text-price-modal-happy">{{
                                    selectedOrder.total.toFixed(2) + ' €'
                                }}</span>
                            </p>
                        </div>
                        <div class="div-second-content-modal-show-order-happy">
                            <p class="text-modal-order-happy">
                                {{ 'Id° : ' + selectedOrder.order_id }}
                            </p>
                            <p
                                v-if="
                                    selectedOrder.shipping_price &&
                                    parseFloat(selectedOrder.shipping_price) !== 0.0
                                "
                                class="text-modal-order-happy"
                            >
                                frais de livraison :
                                <span class="text-price-modal-happy">
                                    {{ parseFloat(selectedOrder.shipping_price) + ' €' }}
                                </span>
                            </p>
                        </div>

                        <div class="div-third-content-modal-show-order-happy">
                            <p
                                class="text-modal-order-happy"
                                v-if="selectedOrder.payment_method === 'Non Payé'"
                            >
                                Mode de paiement :
                                <span class="font-normal">
                                    {{ selectedOrder.payment_method }}</span
                                >
                            </p>

                            <p class="text-modal-order-happy">
                                Méthode de récupération :
                                <span class="font-normal">
                                    {{ selectedOrder.shipping_method }}</span
                                >
                            </p>
                        </div>

                        <div class="div-second-content-modal-show-order-happy">
                            <p :class="getPaidClass(selectedOrder)">
                                {{ selectedOrder.payment_status }}
                            </p>
                            <p
                                class="text-modal-order-happy"
                                :class="statusOrder(selectedOrder.order_status_id).class"
                            >
                                {{ statusOrder(selectedOrder.order_status_id).text }}
                            </p>
                        </div>
                    </section>
                    <section class="section-product-modal-show-order-happy">
                        <div
                            v-for="(product, i) in selectedOrder.order_products"
                            :key="i"
                            class="div-product-modal-show-order-happy"
                            :class="{
                                'border-b happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light':
                                    i < selectedOrder.order_products.length - 1
                            }"
                        >
                            <div class="div-infos-product-modal-show-order-happy">
                                <div class="flex items-center">
                                    <img
                                        v-if="product.image"
                                        :src="product.image"
                                        alt="Image du produit"
                                        class="img-modal-show-order-happy"
                                    />
                                    <div class="flex items-start flex-col pl-3">
                                        <p class="text-modal-order-happy">
                                            {{ product.name }}
                                        </p>
                                        <p
                                            class="text-sm font-semibold whitespace-normal"
                                        >
                                            quantité :
                                            <span class="font-normal">{{
                                                product.quantity
                                            }}</span>
                                        </p>
                                    </div>
                                </div>
                                <p class="text-price-modal-happy font-semibold pl-3">
                                    {{ parseFloat(product.price).toFixed(2) }} €
                                </p>
                            </div>

                            <div
                                class="div-options-product-modal-show-order-happy"
                                v-if="product.order_options.length > 0"
                            >
                                <div
                                    v-for="(option, index) in product.order_options"
                                    :key="index"
                                    class="option-modal-show-order-happy"
                                >
                                    <svg
                                        fill="none"
                                        viewBox="0 0 14 11"
                                        class="svg-option-order-happy"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.43483 4.35783L12.2604 7.18344M12.2604 7.18344L9.43483 10.009M12.2604 7.18344H2.01761C1.43241 7.18344 0.958008 6.70906 0.958008 6.12384V1.53223"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <p
                                        class="flex flex-wrap whitespace-break-spaces"
                                        v-if="option.values"
                                    >
                                        {{ option.name }} :
                                        <span
                                            v-for="(value, _iv) in option.values"
                                            :key="value"
                                        >
                                            {{ value
                                            }}<span v-if="_iv < option.values.length - 1"
                                                >{{ ', ' }}
                                            </span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-modal-show-order-happy {
    @apply fixed inset-0 h-full w-full z-30 flex  justify-center;
}

.section-overlay-modal-show-order-happy {
    @apply absolute w-full h-full happy-light:bg-bg-happy-light happy-dark:bg-text-dark-happy-light opacity-30;
}

.section-content-modal-show-order-happy {
    @apply min-w-[19rem] max-w-[34rem] mx-3 mt-32 rounded-md shadow happy-light:shadow-text-dark-happy-light happy-dark:shadow-bg-happy-light flex-col border-2 border-button-yellow-happy-light items-center;
    @apply relative z-10 max-h-[80vh] h-fit;
    @apply happy-light:bg-bg-happy-light happy-light:text-text-dark-happy-light happy-dark:bg-text-dark-happy-light happy-dark:text-bg-happy-light;
}
.header-show-modal-order-happy {
    @apply w-full h-12 bg-button-yellow-happy-light flex pl-4 items-center;
    @apply text-lg font-bold text-gray-800;
}
.section-content-internal-modal-show-order-happy {
    @apply w-full max-h-[65vh] overflow-y-auto;
    @apply flex flex-col items-center;

    min-height: auto;
}

.section-infos-modal-show-order-happy {
    @apply w-full flex flex-col p-3  border-b happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
}

.div-second-content-modal-show-order-happy {
    @apply w-full flex items-center justify-between;
}
.div-third-content-modal-show-order-happy {
    @apply w-full flex flex-col items-start text-sm;
}

.div-first-content-modal-show-order-happy {
    @apply w-full flex justify-between flex-wrap;
}

.text-modal-order-happy {
    @apply font-semibold;
}
.text-price-modal-happy {
    @apply text-button-yellow-happy-light;
}
.wait-class {
    @apply bg-border-red-happy-light text-bg-happy-light py-1 px-2 rounded text-sm min-w-24 text-center;
}

.preparation-class {
    @apply bg-bleu-happy py-1 px-2 rounded text-sm text-bg-happy-light  min-w-24 text-center;
}

.approve-class {
    @apply bg-button-yellow-happy-light py-1 px-2 rounded text-sm min-w-24 text-center text-text-dark-happy-light;
}

.ready-class {
    @apply bg-green-happy py-1 px-2 rounded text-sm min-w-24 text-center text-text-dark-happy-light;
}

.delivery-class {
    @apply bg-gray-500 text-bg-happy-light py-1 px-2 rounded text-sm min-w-24 text-center;
}
.success {
    @apply font-semibold text-green-happy;
}
.error {
    @apply font-semibold text-border-red-happy-light;
}

.section-product-modal-show-order-happy {
    @apply max-w-full flex flex-col flex-wrap gap-2;
}

.div-product-modal-show-order-happy {
    @apply max-w-full flex flex-col flex-wrap whitespace-pre-wrap break-all px-3 py-2;
}

.div-infos-product-modal-show-order-happy {
    @apply flex items-center justify-between flex-wrap;
}
.img-modal-show-order-happy {
    @apply w-14 h-14 object-contain rounded-md;
}
.div-options-product-modal-show-order-happy {
    @apply w-full flex flex-col;
}
.option-modal-show-order-happy {
    @apply w-full flex gap-1 items-start;
    @apply flex-wrap;
}
.svg-option-order-happy {
    @apply w-4 h-4 mt-1 happy-dark:stroke-bg-happy-light happy-light:stroke-text-dark-happy-light;
}
</style>
